export type ProductTier = "starter" | "pro" | "premium";

export function mapSubscriptionToProductTier(sub: ProductTier | string | null | undefined): ProductTier {
  if (!sub) return "starter";
  switch (sub.toLowerCase()) {
    case "premium":
    case "academic_pro":
      return "premium";
    case "pro":
    case "professional":
      return "pro";
    case "starter":
    case "free":
    default:
      return "starter";
  }
}

/**
 * Checks if a given tier is granted access to a required tier feature.
 * Hierarchy: starter < pro < premium
 */
export function hasTierAccess(currentTier: ProductTier, requiredTier: ProductTier): boolean {
  if (requiredTier === "starter") return true;
  if (requiredTier === "pro" && (currentTier === "pro" || currentTier === "premium")) return true;
  if (requiredTier === "premium" && currentTier === "premium") return true;
  return false;
}
